// ===========================================
// ENTITY TOGGLE — US / EU, separate, seen together
// ===========================================
// The one control behind "US and EU stay separate, seen together": each side
// is its own set of books; Combined shows both, with converted totals labeled
// by the day's ECB rate wherever the server added across currencies.

import clsx from 'clsx';

export type EntityView = 'us' | 'eu' | 'all';

const OPTIONS: Array<{ value: EntityView; label: string; title: string }> = [
  { value: 'us', label: 'US', title: 'Only the US entity’s accounts and money' },
  { value: 'eu', label: 'EU', title: 'Only the EU entity’s accounts and money' },
  { value: 'all', label: 'Combined', title: 'Both entities — converted totals carry the ECB rate date' },
];

export default function EntityToggle({ value, onChange }: { value: EntityView; onChange: (v: EntityView) => void }) {
  return (
    <div className="inline-flex rounded-full bg-slate-100 p-0.5" role="group" aria-label="Entity">
      {OPTIONS.map((o) => (
        <button
          key={o.value}
          type="button"
          title={o.title}
          onClick={() => onChange(o.value)}
          className={clsx(
            'px-3 py-1 rounded-full text-xs font-medium transition-colors',
            value === o.value ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-500 hover:text-slate-700',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}

// The query param the wholesale/hub endpoints expect: us|eu, or nothing for Combined.
export const entityParam = (v: EntityView): string | undefined => (v === 'all' ? undefined : v);
